import { IonContent, IonPage, IonSpinner, IonCard, IonCardContent, IonButton } from '@ionic/react';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { verifyAccountDeletion } from '../services/deleteAccountService';

const VerifyDeletion: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verifyToken = async () => {
      // Extract token from URL query params
      const params = new URLSearchParams(location.search);
      const token = params.get('token');

      if (!token) {
        setStatus('error');
        setMessage('Invalid verification link - no token provided');
        return;
      }

      // Call the verification service
      const result = await verifyAccountDeletion(token);

      if (result.success) {
        setStatus('success');
        setMessage('Your account deletion has been verified! Your account will be permanently deleted in 30 days. You can cancel at any time by logging into your account.');
      } else {
        setStatus('error');
        setMessage(result.error || 'Failed to verify account deletion');
      }
    };

    verifyToken();
  }, [location.search]);

  return (
    <IonPage>
      <IonContent className="ion-padding">
        <div style={{ maxWidth: '600px', margin: '100px auto' }}>
          <IonCard>
            <IonCardContent>
              {status === 'loading' && (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                  <IonSpinner name="crescent" />
                  <p>Verifying your account deletion request...</p>
                </div>
              )}

              {status === 'success' && (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                  <h2 style={{ color: '#10b981' }}>✅ Verification Successful</h2>
                  <p>{message}</p>
                  <div style={{
                    background: '#fef3c7',
                    border: '1px solid #f59e0b',
                    borderRadius: '8px',
                    padding: '20px',
                    marginTop: '20px',
                    textAlign: 'left'
                  }}>
                    <h3 style={{ marginTop: 0, fontSize: '18px' }}>💡 Changed Your Mind?</h3>
                    <p style={{ marginBottom: 0 }}>
                      You can cancel this deletion request at any time within the next 30 days.
                      Just open the Dice Cat app, go to <strong>Profile → Account Settings</strong>,
                      and click <strong>"Cancel Account Deletion"</strong>.
                    </p>
                  </div>
                  <IonButton
                    expand="block"
                    onClick={() => history.push('/tabs/profile')}
                    style={{ marginTop: '20px' }}
                  >
                    Go to Profile
                  </IonButton>
                </div>
              )}

              {status === 'error' && (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                  <h2 style={{ color: '#ef4444' }}>❌ Verification Failed</h2>
                  <p>{message}</p>
                  <IonButton
                    expand="block"
                    onClick={() => history.push('/tabs/profile')}
                    style={{ marginTop: '20px' }}
                  >
                    Go to Profile
                  </IonButton>
                </div>
              )}
            </IonCardContent>
          </IonCard>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default VerifyDeletion;
